/* ============================================================
   RF2T Franchise Easter Eggs
   ------------------------------------------------------------
   Watches every search box (name="q") and, when a shopper types
   a franchise name, fires a quick themed flourish — a chiptune
   jingle plus short-lived sprites animated by
   rf2t-franchise-eggs.css.

   Uses generic iconic items (rupee, coin, ring, capture ball,
   energy orb) and synthesized tones — no ripped art or audio.

   Loaded globally from theme.liquid; one delegated listener
   survives spa-nav content swaps.
   ============================================================ */
(function () {
  'use strict';

  if (window.__rf2tFranchiseBound) return;
  window.__rf2tFranchiseBound = true;

  /* ── Matching ──────────────────────────────────────────────
     Token-based prefix match so full titles trigger
     ("the legend of zelda", "super mario odyssey", "metroid
     dread") while avoiding false hits like "panasonic" -> sonic. */
  var FRANCHISES = [
    { key: 'zelda',   words: ['zelda', 'hyrule', 'triforce', 'ganon'] },
    { key: 'mario',   words: ['mario', 'luigi', 'yoshi', 'bowser'] },
    { key: 'sonic',   words: ['sonic', 'hedgehog'] },
    { key: 'metroid', words: ['metroid', 'samus'] },
    { key: 'pokemon', words: ['pokemon', 'pokeball', 'pokedex', 'pikachu'] }
  ];

  function deburr(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(new RegExp('[̀-ͯ]', 'g'), '');
  }
  function matchFranchise(value) {
    var tokens = deburr(value).split(/[^a-z0-9]+/);
    for (var t = 0; t < tokens.length; t++) {
      var tok = tokens[t];
      if (!tok) continue;
      for (var i = 0; i < FRANCHISES.length; i++) {
        var w = FRANCHISES[i].words;
        for (var j = 0; j < w.length; j++) {
          if (tok.indexOf(w[j]) === 0) return FRANCHISES[i].key;
        }
      }
    }
    return null;
  }

  // Fire each franchise once until the box stops matching it.
  var lastFired = null;
  function onValue(value) {
    var key = matchFranchise(value);
    if (key && key !== lastFired) { lastFired = key; fire(key); }
    else if (!key) { lastFired = null; }
  }

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || (t.name !== 'q' && (!t.getAttribute || t.getAttribute('name') !== 'q'))) return;
    onValue(t.value);
  });

  // Direct loads / form submits land on /search?q=…
  function scan() {
    try {
      var q = new URLSearchParams(window.location.search).get('q');
      if (q) { onValue(q); return; }
    } catch (_) { /* ignore */ }
    var ins = document.querySelectorAll('input[name="q"]');
    for (var i = 0; i < ins.length; i++) { if (ins[i].value) { onValue(ins[i].value); return; } }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  window.addEventListener('popstate', function () { lastFired = null; setTimeout(scan, 60); });

  /* ── FX layer ──────────────────────────────────────────────── */
  var layer = null;
  function getLayer() {
    if (layer && layer.isConnected) return layer;
    layer = document.createElement('div');
    layer.className = 'rf2t-egg-layer';
    layer.setAttribute('aria-hidden', 'true');
    document.body.appendChild(layer);
    return layer;
  }
  function spawn(cls, html, styles, life) {
    var d = document.createElement('div');
    d.className = 'rf2t-egg ' + cls;
    d.innerHTML = html;
    if (styles) for (var k in styles) d.style.setProperty(k, styles[k]);
    getLayer().appendChild(d);
    setTimeout(function () { if (d.parentNode) d.parentNode.removeChild(d); }, life);
    return d;
  }
  function rand(a, b) { return a + Math.random() * (b - a); }

  /* ── Sprites (generic iconic shapes) ───────────────────────── */
  var RUPEE =
    '<svg viewBox="0 0 24 36"><polygon points="12,1 22,12 12,35 2,12" fill="#36d36b" stroke="#0a7a36" stroke-width="1.5"/>' +
    '<polygon points="12,1 22,12 12,18 2,12" fill="#9bf3bd" opacity="0.7"/></svg>';
  var HEART =
    '<svg viewBox="0 0 24 24"><path d="M12 21S2 14.5 2 8.2A4.8 4.8 0 0 1 12 6 4.8 4.8 0 0 1 22 8.2C22 14.5 12 21 12 21Z" ' +
    'fill="#ff4d6d" stroke="#9e1230" stroke-width="1"/><circle cx="8" cy="8" r="1.6" fill="#ffd0db"/></svg>';
  var COIN =
    '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="11" fill="#ffcc33" stroke="#a9760a" stroke-width="2"/>' +
    '<ellipse cx="12" cy="12" rx="4.5" ry="8" fill="#ffe892"/></svg>';
  var RING =
    '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9.5" fill="none" stroke="#ffce2e" stroke-width="4"/>' +
    '<circle cx="12" cy="12" r="9.5" fill="none" stroke="#fff3b0" stroke-width="1.4"/></svg>';
  var BALL =
    '<svg viewBox="0 0 32 32"><circle cx="16" cy="16" r="15" fill="#f6f6f6" stroke="#1c1c1c" stroke-width="2"/>' +
    '<path d="M1 16a15 15 0 0 1 30 0Z" fill="#ef3d3d"/><rect x="1" y="14.3" width="30" height="3.4" fill="#1c1c1c"/>' +
    '<circle cx="16" cy="16" r="4.6" fill="#fff" stroke="#1c1c1c" stroke-width="2"/></svg>';
  var ORB =
    '<svg viewBox="0 0 40 40"><defs><radialGradient id="rf2tOrb" cx="50%" cy="40%" r="60%">' +
    '<stop offset="0%" stop-color="#eafdff"/><stop offset="55%" stop-color="#5fd6ff"/>' +
    '<stop offset="100%" stop-color="#1f7fd6"/></radialGradient></defs>' +
    '<circle cx="20" cy="20" r="13" fill="url(#rf2tOrb)"/><circle cx="20" cy="20" r="13" fill="none" stroke="#d6f6ff" stroke-width="1.5"/></svg>';
  var BLOCK =
    '<svg viewBox="0 0 28 28"><rect x="1" y="1" width="26" height="26" rx="3" fill="#f5a623" stroke="#7a4300" stroke-width="2"/>' +
    '<text x="14" y="21" text-anchor="middle" font-size="19" font-weight="900" fill="#fff" ' +
    'font-family="Arial Black, sans-serif">?</text>' +
    '<circle cx="4.5" cy="4.5" r="1.3" fill="#7a4300"/><circle cx="23.5" cy="4.5" r="1.3" fill="#7a4300"/>' +
    '<circle cx="4.5" cy="23.5" r="1.3" fill="#7a4300"/><circle cx="23.5" cy="23.5" r="1.3" fill="#7a4300"/></svg>';
  var SPARK =
    '<svg viewBox="0 0 16 16"><path d="M8 0 9.6 6.4 16 8 9.6 9.6 8 16 6.4 9.6 0 8 6.4 6.4Z" fill="#fff3b0"/></svg>';

  var ICON = { zelda: RUPEE, mario: COIN, sonic: RING, metroid: ORB, pokemon: BALL };

  /* ── Audio (synthesized, lazy) ─────────────────────────────── */
  var actx = null, amaster = null;
  function audio() {
    if (actx) { if (actx.state === 'suspended') actx.resume(); return actx; }
    var AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    try {
      actx = new AC();
      amaster = actx.createGain();
      amaster.gain.value = 0.16;
      amaster.connect(actx.destination);
    } catch (_) { actx = null; }
    return actx;
  }
  function note(type, f, at, dur, g, glide) {
    if (!actx) return;
    var o = actx.createOscillator(), ga = actx.createGain();
    o.type = type;
    o.frequency.setValueAtTime(f, at);
    if (glide && glide !== f) o.frequency.exponentialRampToValueAtTime(Math.max(1, glide), at + dur);
    ga.gain.setValueAtTime(0.0001, at);
    ga.gain.exponentialRampToValueAtTime(g, at + 0.008);
    ga.gain.exponentialRampToValueAtTime(0.0001, at + dur);
    o.connect(ga).connect(amaster);
    o.start(at); o.stop(at + dur + 0.02);
  }

  var SOUND = {
    zelda: function () {
      if (!audio()) return; var t = actx.currentTime + 0.02;
      [784, 740, 622, 440, 415, 659, 831, 1047].forEach(function (f, i) {
        note('square', f, t + i * 0.12, 0.13, 0.5);
      });
    },
    mario: function () {
      if (!audio()) return; var t = actx.currentTime + 0.02;
      note('square', 988, t, 0.07, 0.6);
      note('square', 1319, t + 0.07, 0.42, 0.6);
    },
    sonic: function () {
      if (!audio()) return; var t = actx.currentTime + 0.02;
      note('triangle', 1568, t, 0.12, 0.55, 3136);
      note('triangle', 2093, t + 0.05, 0.16, 0.4, 3520);
    },
    metroid: function () {
      if (!audio()) return; var t = actx.currentTime + 0.02;
      [659, 784, 988, 1319].forEach(function (f, i) { note('square', f, t + i * 0.1, 0.12, 0.5); });
      note('square', 1319, t + 0.42, 0.5, 0.45);
      note('triangle', 660, t + 0.42, 0.5, 0.3, 1320);
    },
    pokemon: function () {
      if (!audio()) return; var t = actx.currentTime + 0.02;
      note('triangle', 620, t, 0.24, 0.4, 130);                 // throw whoosh
      [1.0, 1.35, 1.7].forEach(function (dt) { note('square', 190, t + dt, 0.05, 0.5, 140); }); // wiggle ticks
      [784, 1047, 1319].forEach(function (f, i) { note('square', f, t + 2.0 + i * 0.12, 0.14, 0.5); }); // caught!
    }
  };

  /* ── Effects ───────────────────────────────────────────────── */
  var EFFECT = {
    zelda: function () {
      for (var i = 0; i < 14; i++) {
        var heart = Math.random() < 0.35;
        spawn(heart ? 'rf2t-egg--float' : 'rf2t-egg--float', heart ? HEART : RUPEE, {
          '--x': rand(5, 92) + '%',
          '--rise': rand(58, 88) + 'vh',
          '--drift': rand(-70, 70) + 'px',
          '--spin': rand(-70, 70) + 'deg',
          '--dur': rand(1.8, 3) + 's',
          '--delay': rand(0, 0.5) + 's',
          '--sz': rand(20, 36) + 'px'
        }, 3700);
      }
      spawn('rf2t-egg--secret', SPARK, {}, 1200);
    },
    mario: function () {
      spawn('rf2t-egg--block', BLOCK, {}, 650);
      spawn('rf2t-egg--coin', COIN, {}, 1000);
    },
    sonic: function () {
      var n = 14;
      for (var i = 0; i < n; i++) {
        var ang = (i / n) * Math.PI * 2 + rand(-0.3, 0.3);
        var dist = rand(120, 240);
        spawn('rf2t-egg--ring', RING, {
          '--tx': Math.cos(ang) * dist + 'px',
          '--ty': Math.sin(ang) * dist + 'px',
          'width': rand(20, 30) + 'px',
          'height': rand(20, 30) + 'px'
        }, 1500);
      }
    },
    metroid: function () {
      spawn('rf2t-egg--orb', ORB, {}, 1700);
      spawn('rf2t-egg--pulse', '', { '--delay': '0s' }, 1300);
      spawn('rf2t-egg--pulse', '', { '--delay': '0.28s' }, 1600);
      for (var i = 0; i < 8; i++) {
        var ang = rand(0, Math.PI * 2), dist = rand(60, 120);
        spawn('rf2t-egg--spark', SPARK, {
          '--sx': Math.cos(ang) * dist + 'px',
          '--sy': Math.sin(ang) * dist + 'px',
          '--delay': rand(0, 0.3) + 's'
        }, 1300);
      }
    },
    pokemon: function () {
      spawn('rf2t-egg--ball', BALL, {}, 2500);
      setTimeout(function () {
        for (var i = 0; i < 7; i++) {
          spawn('rf2t-egg--catch', SPARK, { '--ca': (i / 7 * 360) + 'deg' }, 900);
        }
      }, 1980);
    }
  };

  function fire(key) {
    audio();
    if (SOUND[key]) SOUND[key]();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { spawn('rf2t-egg--simple', ICON[key], {}, 1500); return; }
    if (EFFECT[key]) EFFECT[key]();
  }
})();
